interface IconProps {
  className?: string;
}

/** Basket glyph of the product card add button on the DubaiExpress product page. */
const CartSmallIcon = ({ className }: IconProps) => (
  <svg viewBox="0 0 16 16" fill="none" aria-hidden className={className}>
    <path
      d="M9.99967 7.33317L9.33301 13.3332M12.6663 7.33317L9.99967 2.6665M1.33301 7.33317H14.6663M2.33301 7.33317L3.39967 12.2665C3.46201 12.5722 3.62957 12.8464 3.8732 13.0413C4.11682 13.2362 4.42108 13.3395 4.73301 13.3332H11.2663C11.5783 13.3395 11.8825 13.2362 12.1262 13.0413C12.3698 12.8464 12.5373 12.5722 12.5997 12.2665L13.733 7.33317M2.99967 10.3332H12.9997M3.33301 7.33317L5.99967 2.6665M5.99967 7.33317L6.66634 13.3332"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CartSmallIcon;
